import UnrecognizedSentences from './UnrecognizedSentences';

export default UnrecognizedSentences;
